import { render, staticRenderFns } from "./AlertSettingsHeader.vue?vue&type=template&id=656245ce&scoped=true&lang=pug&"
import script from "./AlertSettingsHeader.vue?vue&type=script&lang=ts&"
export * from "./AlertSettingsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AlertSettingsHeader.vue?vue&type=style&index=0&id=656245ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656245ce",
  null
  
)

export default component.exports